// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__gwTQ6","Completion":"index_Completion__pJz4k","viewBox":"index_viewBox__2diIe"};